import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/service-location-actions';
import { ServiceLocationActions } from '../constants';
import { IServiceLocation } from 'src/types/service-locations';

export interface ServiceLocationState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IServiceLocation>;
    current: IServiceLocation | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
};

export function serviceLocations(
    state: ServiceLocationState = initialState,
    action: Actions | any,
): ServiceLocationState {
    switch (action.type) {
        case requestType(ServiceLocationActions.STAFF_PERSIST_SERVICE_LOCATION):
            return { ...state, error: '', inProgress: true };
        case successType(ServiceLocationActions.STAFF_PERSIST_SERVICE_LOCATION):
            return { ...state, inProgress: false };
        case failureType(ServiceLocationActions.STAFF_PERSIST_SERVICE_LOCATION):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATIONS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATIONS):
            return { ...state, data: action.payload, inProgress: false };
        case failureType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATIONS):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATION):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATION):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ServiceLocationActions.STAFF_FETCH_SERVICE_LOCATION):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ServiceLocationActions.STAFF_DELETE_SERVICE_LOCATION):
            return { ...state, error: '', inProgress: true };
        case successType(ServiceLocationActions.STAFF_DELETE_SERVICE_LOCATION):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((item: IServiceLocation) => {
                        return item.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ServiceLocationActions.STAFF_DELETE_SERVICE_LOCATION):
            return { ...state, inProgress: false, error: 'Service Location has deep relations' ?? 'Unknown error' };
        default:
            return state;
    }
}
